import React from 'react';
import { orderBy, } from 'lodash';
import { format as formatDate, } from 'date-fns';

import firebase from '../../firebase';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import Page from '../hocs/Page';

const db = firebase.firestore();
const notificationsRef = db.collection('notifications');

export default Page(function Notifications (props) {
  const now = new Date();
  const notifications = useCollectionSubscription(notificationsRef);
  // 掲載開始日が到来したもののみ、開始日の降順で表示
  const publishedNotifications = orderBy(
    notifications.filter(_ => _.publishedAt != null && _.publishedAt.toDate() <= now),
    _ => _.publishedAt.toDate(),
    'desc',
  );

  return (
    <div className="notifications container">
      <div className="my-4">
        <h4 className="mb-4">お知らせ</h4>
        {
          publishedNotifications.length === 0 ? (
            <div className="text-muted">お知らせはありません。</div>
          ) : (
            <div className="d-flex flex-column gap-3">
              {
                publishedNotifications.map((notification) => {
                  const { id, title, image, publishedAt, } = notification;

                  return (
                    <div key={id} className="card">
                      {
                        image?.downloadUrl && (
                          <img src={image.downloadUrl} alt={title} className="card-img-top" style={{ objectFit: 'contain', maxHeight: 320, }} />
                        )
                      }
                      <div className="card-body">
                        <div className="text-muted small mb-1">
                          {formatDate(publishedAt.toDate(), 'yyyy/MM/dd')}
                        </div>
                        <h5 className="card-title mb-0">{title}</h5>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          )
        }
      </div>
    </div>
  );
});
